import React from "react";
import { Button, StyledText } from "../../../../components/common";
import { BackIcon } from "../../../../components/svgs";
import styled from "styled-components";
import CautionIcon from "../../../../components/svgs/cautionIcon";

const ModalOverlay = styled.div`
  position: fixed;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px 50px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  // margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const InappropriateCommentModal = ({ onBackDropClick }) => {
  return (
    <>
      <ModalOverlay onClick={onBackDropClick} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            width: 50,
            height: 8,
            backgroundColor: "#cbcbcb",
            borderRadius: 10,
          }}
        />
        <Header>
          <CloseButton onClick={onBackDropClick}>
            <BackIcon />
          </CloseButton>
        </Header>
        
        <div>
          <CautionIcon width={70} height={70} fill={"#ffcc00"} stroke="#000"/>
        </div>

        <StyledText style={{
          fontFamily: "MTNMedium",
          fontSize: 22,
          marginTop: 10,
          marginBottom: 5,
          textAlign: "center"
        }}>
          Comment Rejected
        </StyledText>
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
            marginBottom: 20,
            marginTop: 5,
          }}
        >
          Your comment can't be published because it contains inappropriate content.
        </StyledText>
        <Button
          style={{ backgroundColor: "#ffcc00", width: "80%" }}
          onClick={onBackDropClick}
        >
          <StyledText color="#333">Edit comment</StyledText>
        </Button>
      </ModalContent>
    </>
  );
};

export default InappropriateCommentModal;
